import { render, staticRenderFns } from "./SearchTabTheme0.vue?vue&type=template&id=b8e980f4&scoped=true"
import script from "./SearchTabTheme0.vue?vue&type=script&lang=js"
export * from "./SearchTabTheme0.vue?vue&type=script&lang=js"
import style0 from "./SearchTabTheme0.vue?vue&type=style&index=0&id=b8e980f4&prod&scoped=true&lang=css"
import style1 from "./SearchTabTheme0.vue?vue&type=style&index=1&id=b8e980f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e980f4",
  null
  
)

export default component.exports